import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbairoundtripcabfare() {



  const cardData = {


  keyword: "Pune to Mumbai Round Trip Cab Fare",

  headingDescription: "Trustline Travels offers affordable Pune to Mumbai round trip cab fare with reliable, comfortable, and chauffeur-driven taxi services for business travel, family vacations, airport transfers, corporate meetings, and weekend getaways. Whether you need a same-day return trip or a multi-day round journey, we provide well-maintained AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles at transparent prices with no hidden charges. Our professional drivers ensure safe travel, timely pickups, flexible return schedules, and a hassle-free experience. With easy online booking, doorstep pickup, and 24/7 customer support, Trustline Travels is the trusted choice for Pune to Mumbai round trip taxi services.",

  topPlaces: [
    {
      title: "Andheri East",
      description: "Andheri East is one of Mumbai's leading commercial hubs, home to corporate offices, business parks, hotels, and excellent connectivity to the international airport."
    },
    {
      title: "Lower Parel",
      description: "Lower Parel is a premier business district featuring multinational companies, commercial towers, premium offices, and corporate headquarters."
    },
    {
      title: "Chembur",
      description: "Chembur is a well-developed commercial and residential locality with business centers, educational institutions, and seamless connectivity across Mumbai."
    },
    {
      title: "Ghatkopar",
      description: "Ghatkopar is a busy commercial area known for shopping complexes, corporate offices, business establishments, and metro connectivity."
    },
    {
      title: "Reliance Corporate Park",
      description: "Reliance Corporate Park in Ghansoli is one of India's largest corporate campuses with technology centers, business operations, and modern infrastructure."
    },
    {
      title: "Mindspace Malad",
      description: "Mindspace Malad is a prominent IT and commercial business park housing multinational companies, technology firms, and corporate offices."
    },
    {
      title: "Juhu Beach",
      description: "Juhu Beach is one of Mumbai's most famous beaches, attracting visitors with its lively atmosphere, local street food, and spectacular sunset views."
    },
    {
      title: "Kanheri Caves",
      description: "Kanheri Caves are ancient Buddhist rock-cut monuments located inside Sanjay Gandhi National Park, showcasing Mumbai's rich historical heritage."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is a vibrant shopping destination offering fashion boutiques, handicrafts, cafés, and heritage architecture."
    },
    {
      title: "Haji Ali Dargah",
      description: "Haji Ali Dargah is a renowned spiritual landmark situated on an islet in the Arabian Sea, admired for its beautiful Indo-Islamic architecture."
    }
  ],






"services": [
  {
    "name": "Pune to Mumbai Round Trip Cab Fare",
    "description": "Check Pune to Mumbai round trip cab fare with transparent pricing for Sedan, Ertiga, Innova Crysta, SUV, and premium AC cabs. Enjoy comfortable travel with professional drivers, doorstep pickup, and no hidden charges."
  },
  {
    "name": "Pune to Mumbai Cab Fare",
    "description": "Get the latest Pune to Mumbai cab fare for one-way and round-trip journeys with affordable rates, clean AC vehicles, and reliable taxi service."
  },
  {
    "name": "Pune to Mumbai Taxi Fare",
    "description": "Compare Pune to Mumbai taxi fare for Sedan, Ertiga, Innova Crysta, and SUV cabs with fixed pricing and comfortable travel."
  },
  {
    "name": "Pune to Mumbai Cab Price",
    "description": "Check Pune to Mumbai cab price with affordable packages for airport transfers, business trips, family travel, and outstation rides."
  },
  {
    "name": "Pune to Mumbai Taxi Price",
    "description": "Find Pune to Mumbai taxi price with transparent rates for one-way, round-trip, and airport transfer services."
  },
  {
    "name": "Pune to Mumbai Cab Charges",
    "description": "Know Pune to Mumbai cab charges for Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles with no hidden costs."
  },
  {
    "name": "Pune to Mumbai Cab Cost",
    "description": "Estimate Pune to Mumbai cab cost with flexible travel options, fixed fares, and professional chauffeur service."
  },
  {
    "name": "Pune to Mumbai Taxi Cost",
    "description": "Check Pune to Mumbai taxi cost for affordable intercity travel with comfortable AC cars and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Cab Booking",
    "description": "Book Pune to Mumbai cab online with instant confirmation, multiple vehicle options, and 24x7 customer support."
  },
  {
    "name": "Pune to Mumbai Taxi Booking",
    "description": "Reserve Pune to Mumbai taxi booking for safe, reliable, and affordable travel with doorstep pickup."
  },
  {
    "name": "Pune to Mumbai Cab Service",
    "description": "Choose Pune to Mumbai cab service for one-way, round-trip, airport transfers, corporate travel, and family trips."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Reliable Pune to Mumbai taxi service with clean AC vehicles, trained drivers, and transparent pricing."
  },
  {
    "name": "Pune to Mumbai One Way Cab Fare",
    "description": "Check Pune to Mumbai one way cab fare with budget-friendly pricing and pay only for your single journey."
  },
  {
    "name": "Pune to Mumbai Car Rental",
    "description": "Hire Pune to Mumbai car rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Book Pune to Mumbai outstation cab for safe, comfortable, and affordable long-distance travel."
  },
  {
    "name": "Pune to Mumbai Private Cab",
    "description": "Hire a private Pune to Mumbai cab for personalized travel with flexible pickup, drop, and travel timings."
  },
  {
    "name": "Pune to Mumbai AC Cab",
    "description": "Travel comfortably in Pune to Mumbai AC cabs with clean interiors, experienced chauffeurs, and fixed fares."
  },
  {
    "name": "Pune to Mumbai Cab Package",
    "description": "Explore Pune to Mumbai cab packages for one-way, round-trip, airport transfer, and business travel."
  },
  {
    "name": "Pune to Mumbai Intercity Cab",
    "description": "Book Pune to Mumbai intercity cab with reliable service, comfortable vehicles, and affordable pricing."
  },
  {
    "name": "Pune to Mumbai Cab Rates",
    "description": "Check Pune to Mumbai cab rates for Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles."
  },
  {
    "name": "Innova Crysta Pune to Mumbai Fare",
    "description": "Know Innova Crysta Pune to Mumbai fare for premium family and corporate travel with spacious seating."
  },
  {
    "name": "Ertiga Pune to Mumbai Fare",
    "description": "Check Ertiga Pune to Mumbai fare for affordable 6 to 7-seater family and group travel."
  },
  {
    "name": "Sedan Pune to Mumbai Fare",
    "description": "View Sedan Pune to Mumbai fare for Swift Dzire, Hyundai Aura, Etios, and similar comfortable vehicles."
  },
  {
    "name": "Swift Dzire Pune to Mumbai Fare",
    "description": "Find Swift Dzire Pune to Mumbai fare with economical pricing for one-way and round-trip travel."
  },
  {
    "name": "Hyundai Aura Pune to Mumbai Fare",
    "description": "Check Hyundai Aura Pune to Mumbai fare with affordable rates for business and family trips."
  },
  {
    "name": "Kia Carens Pune to Mumbai Fare",
    "description": "Book Kia Carens Pune to Mumbai fare for spacious premium travel with comfortable seating."
  },
  {
    "name": "SUV Cab Pune to Mumbai Fare",
    "description": "Explore SUV cab Pune to Mumbai fare for comfortable long-distance travel with premium vehicles."
  },
  {
    "name": "Premium Cab Pune to Mumbai Fare",
    "description": "Check premium cab Pune to Mumbai fare for luxury travel with top-class vehicles and chauffeurs."
  },
  {
    "name": "Pune to Mumbai Airport Round Trip Cab Fare",
    "description": "Get Pune to Mumbai Airport round trip cab fare with fixed pricing, airport pickup and return service."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Fare",
    "description": "Check Pune to Mumbai Airport taxi fare for T1, T2, domestic, and international airport transfers."
  },
  {
    "name": "Pune to T2 Airport Cab Fare",
    "description": "Find Pune to T2 Airport cab fare with affordable pricing for comfortable airport transfers."
  },
  {
    "name": "Pune to T1 Airport Cab Fare",
    "description": "Check Pune to T1 Airport cab fare with reliable taxi service and fixed prices."
  },
  {
    "name": "Pune to Mumbai Airport Cab Charges",
    "description": "Know Pune to Mumbai Airport cab charges with transparent pricing for Sedan, Ertiga, and Innova Crysta."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Cost",
    "description": "Estimate Pune to Mumbai Airport taxi cost with affordable airport transfer packages."
  },
  {
    "name": "Pune to Mumbai Same Day Return Cab Fare",
    "description": "Book Pune to Mumbai same day return cab fare for business meetings, airport transfers, and quick trips."
  },
  {
    "name": "Pune to Mumbai Round Trip Taxi Price",
    "description": "Compare Pune to Mumbai round trip taxi price for different vehicle categories with fixed fares."
  },
  {
    "name": "Pune to Mumbai Cab Fare Including Toll",
    "description": "Check Pune to Mumbai cab fare including toll for complete pricing with no hidden charges."
  },
  {
    "name": "Pune to Mumbai Cab Fare with Driver",
    "description": "Get Pune to Mumbai cab fare with professional driver, fuel-efficient vehicles, and comfortable travel."
  },
  {
    "name": "Pune to Mumbai Taxi Fare Round Trip",
    "description": "View Pune to Mumbai taxi fare round trip with flexible travel plans and affordable packages."
  },
  {
    "name": "Affordable Pune to Mumbai Round Trip Cab",
    "description": "Choose affordable Pune to Mumbai round trip cab service with fixed pricing, clean AC cars, and experienced drivers."
  },
  {
    "name": "Best Pune to Mumbai Cab Fare Online",
    "description": "Book the best Pune to Mumbai cab fare online with instant confirmation, secure booking, and transparent pricing."
  },
  {
    "name": "Fixed Price Pune to Mumbai Cab",
    "description": "Reserve a fixed price Pune to Mumbai cab with no surge pricing, hidden charges, or last-minute surprises."
  },
  {
    "name": "Pune to Mumbai Intercity Round Trip Cab",
    "description": "Book Pune to Mumbai intercity round trip cab for family vacations, business travel, airport transfers, and same-day return journeys."
  }
],

"tableData": [
  ["Pune to Mumbai Round Trip Cab Fare", "Pune to Mumbai Cab Fare"],
  ["Pune to Mumbai Taxi Fare", "Pune to Mumbai Cab Price"],
  ["Pune to Mumbai Taxi Price", "Pune to Mumbai Cab Charges"],
  ["Pune to Mumbai Cab Cost", "Pune to Mumbai Taxi Cost"],
  ["Pune to Mumbai Cab Booking", "Pune to Mumbai Taxi Booking"],
  ["Pune to Mumbai Cab Service", "Pune to Mumbai Taxi Service"],
  ["Pune to Mumbai One Way Cab Fare", "Pune to Mumbai Car Rental"],
  ["Pune to Mumbai Outstation Cab", "Pune to Mumbai Private Cab"],
  ["Pune to Mumbai AC Cab", "Pune to Mumbai Cab Package"],
  ["Pune to Mumbai Intercity Cab", "Pune to Mumbai Cab Rates"],
  ["Innova Crysta Pune to Mumbai Fare", "Ertiga Pune to Mumbai Fare"],
  ["Sedan Pune to Mumbai Fare", "Swift Dzire Pune to Mumbai Fare"],
  ["Hyundai Aura Pune to Mumbai Fare", "Kia Carens Pune to Mumbai Fare"],
  ["SUV Cab Pune to Mumbai Fare", "Premium Cab Pune to Mumbai Fare"],
  ["Pune to Mumbai Airport Round Trip Cab Fare", "Pune to Mumbai Airport Taxi Fare"],
  ["Pune to T2 Airport Cab Fare", "Pune to T1 Airport Cab Fare"],
  ["Pune to Mumbai Airport Cab Charges", "Pune to Mumbai Airport Taxi Cost"],
  ["Pune to Mumbai Same Day Return Cab Fare", "Pune to Mumbai Round Trip Taxi Price"],
  ["Pune to Mumbai Cab Fare Including Toll", "Pune to Mumbai Cab Fare with Driver"],
  ["Pune to Mumbai Taxi Fare Round Trip", "Affordable Pune to Mumbai Round Trip Cab"],
  ["Best Pune to Mumbai Cab Fare Online", "Fixed Price Pune to Mumbai Cab"],
  ["Pune to Mumbai Intercity Round Trip Cab", "Pune to Mumbai Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Affordable Pune to Mumbai Round Trip Cab Fare",
    WhyChoosedescription: "Trustline Travels offers economical round-trip cab fares from Pune to Mumbai with comfortable vehicles and transparent pricing."
  },
  {
    WhyChooseheading: "Transparent Round Trip Pricing",
    WhyChoosedescription: "Receive a detailed fare quotation before booking with no hidden charges, ensuring complete peace of mind."
  },
  {
    WhyChooseheading: "Flexible Return Travel",
    WhyChoosedescription: "Plan your same-day or multi-day return journey with customized round-trip packages to suit your schedule."
  },
  {
    WhyChooseheading: "Wide Range of Cab Options",
    WhyChoosedescription: "Book Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your group size and travel needs."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs",
    WhyChoosedescription: "Our professional drivers ensure safe, punctual, and comfortable travel on the Pune-Mumbai Expressway."
  },
  {
    WhyChooseheading: "Perfect for Business & Family Trips",
    WhyChoosedescription: "Whether you're traveling for meetings, sightseeing, shopping, or family visits, our round-trip cabs are an ideal choice."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Book your Pune to Mumbai round-trip cab anytime with quick quotations and dedicated customer support."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "Travel in clean, air-conditioned vehicles that are regularly serviced for a smooth and enjoyable journey."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Mumbai round trip cab service?",
    answer: "Yes, Trustline Cab offers reliable Pune to Mumbai round-trip cab services for business travel, family trips, airport transfers, and sightseeing."
  },
  {
    question: "How is the Pune to Mumbai round trip cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel duration, total distance, and trip schedule. We provide transparent quotations before booking."
  },
  {
    question: "Can I customize my return timing?",
    answer: "Yes, you can choose same-day return or multi-day round-trip packages according to your travel plans."
  },
  {
    question: "Which vehicles are available for round-trip travel?",
    answer: "We offer Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable round-trip journeys."
  },
  {
    question: "Do you provide Mumbai Airport pickup and return?",
    answer: "Yes, we provide round-trip cab services for Mumbai Airport Terminal 1, Terminal 2, and other locations across Mumbai."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the quotation."
  },
  {
    question: "Can I book a round-trip cab in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and travel schedule."
  },
  {
    question: "Is the cab available for multiple stops during the trip?",
    answer: "Yes, multiple stopovers can be arranged based on your itinerary. Please mention your requirements during booking."
  },
  {
    question: "Is round-trip cab service available 24/7?",
    answer: "Yes, Trustline Cab provides round-trip cab services throughout the day and night."
  },
  {
    question: "How can I book a Pune to Mumbai round-trip cab with Trustline Travels?",
    answer: "Simply share your pickup location, travel date, return schedule, destination, and preferred vehicle to receive an instant fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Bhosale",
    feedback: "We booked a Pune to Mumbai round-trip cab with Trustline Travels for a business visit. The fare was reasonable, the driver was professional, and the return journey was equally comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sonal Deshpande",
    feedback: "Our family needed a round-trip cab from Pune to Mumbai, and Trustline Travels provided excellent service. The vehicle was clean, the pricing was transparent, and the entire trip was well organized.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Round Trip Cab Fare",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-round-trip-cab.webp",
  "description": "Book Pune to Mumbai round trip cab service with Trustline Travels at affordable fares. Enjoy comfortable and reliable round-trip taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7 for Pune Mumbai travel.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6548"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-round-trip-cab-fare"
  }
};


  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Round Trip Cab Fare | Taxi Price | +91 8087080034</title>

  <meta
    name="description"
    content="Check Pune to Mumbai round trip cab fare with Trustline Travels. Book affordable Pune Mumbai taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for comfortable return journeys available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Round Trip Cab Fare, Pune to Mumbai Cab Fare, Pune to Mumbai Taxi Fare, Pune to Mumbai Cab Price, Pune to Mumbai Taxi Price, Pune to Mumbai Cab, Pune Mumbai round trip taxi, Pune to Mumbai return cab fare, Pune Mumbai taxi booking, Pune Mumbai round trip Innova cab, Pune Mumbai airport round trip cab, affordable Pune Mumbai taxi fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/118.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbairoundtripcabfare;